const basics = {
  colors: {
    black: '#000000',
    blackRed: '#420f0f',
    white: '#ffffff',
    creamWhite: '#FFFEFC',
    bloodRed: '#800020',
    fadedRed: '#AA6969',
    solidBlue: '#2844A0',
    neonBlue: '#002FAD',
    fadedBlue: '#9EADD5',
    chalkBlue: '#727884',
    washBlue: '#EDFCFF',
    solidGreen: '#247013',
    washGreen: '#dcffd4',
    deepGreen: '#194f0d',
    yellow: '#FFF11B',
    washOrange: '#fff8eb',
    chalkRed: '#C1B6B6',
    chalk: '#bababa',
    deepRed: '#650019',
    deepBlue: '#010D4E',
    rose: '#AA405B',
    pink: '#DBA3B1',
  },
  transition: 'all 0.25s cubic-bezier(0.3, 0.3, 0.3, 0.3)',
  fonts: {
    Montserrat: "'Montserrat', sans-serif",
    RadioCanada: "'Radio Canada', sans-serif",
    Mulish: "'Mulish', sans-serif",
    RobotoFlex: "'Roboto Flex', sans-serif",
  },
  fontSize: {
    large: '50px',
    xlarge: '85px',
    xxlarge: '100px',
    small: '15px',
    xsmall: '12px',
    xxsmall: '10px',
    medium: '20px',
  },
};

export default basics;
